export const BRAND = {
    name: "SPICEJAM KITCHEN",
    tagline: "Small-batch flavour with Grenada x Jamaica roots.",
    location: "Ontario, Canada",
    email: "spicejamkitchen@gmail.com",
    instagram: "https://www.instagram.com/spicejamkitchen",
    instagramHandle: "@spicejamkitchen",
    facebook: "https://www.facebook.com/profile.php?id=61596208437718",
};

export const IMAGES = {
    heroBackdrop:
        "https://images.unsplash.com/photo-1679711246825-1f2bd51b16d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxiYnElMjByaWJzJTIwc2F1Y2V8ZW58MHx8fHwxNzkzNjA2MjU0fDA&ixlib=rb-4.1.0&q=85",
    jerkJar: "/jerk-jar.webp",
    bbqBottle: "/bbq-jar.webp",
    cookbook:
        "https://images.unsplash.com/photo-1720694025145-6f05b62fa334?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY6Nzd8MHwxfHNlYXJjaHwzfHxjb29rYm9vayUyMGRhcmt8ZW58MHx8fHwxNzkzNjA2MjU0fDA&ixlib=rb-4.1.0&q=85",
    peppers:
        "https://images.unsplash.com/photo-1769195045345-ad54e53edacd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxjaGlsaSUyMHBlcHBlcnxlbnwwfHx8fDE3OTM2MDYyNTR8MA&ixlib=rb-4.1.0&q=85",
    spiceBowls:
        "https://images.unsplash.com/photo-1600728257188-480e132c1610?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxzcGljZXMlMjBib3dsfGVufDB8fHx8MTc5MzUyMjM5MHww&ixlib=rb-4.1.0&q=85",
};

// Owner's heart flag artwork — transparent PNG, used exactly as provided, never redrawn.
export const HEART_FLAG_URL = "/heart-flag.png";
